// Module
var code = `<sub-header header="'Statement of account'"></sub-header>
<div class="alert" ng-if="\$ctrl.isInterbranch">
  <span>
    Minimum date is the system date of the loan's mother branch. Backdated reports are not supported.
  </span>
</div>
<report-approvals-filters
  approved-by-name="\$ctrl.approvedByName"
  checked-by-name="\$ctrl.checkedByName"
  display-report="\$ctrl.displayReport"
  enable-date="true"
  min-date="\$ctrl.minDate"
  date="\$ctrl.date">
</report-approvals-filters>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/customer/loans/statement-of-account/customer-loans-statement.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;